import React from "react";

const NewsLetterIcon = ({ color = "black" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.16602 8L7.91602 10.5L11.666 8"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1663 16.3333H2.49967C2.05765 16.3333 1.63372 16.1577 1.32116 15.8451C1.0086 15.5326 0.833008 15.1087 0.833008 14.6666V6.33329C0.833008 5.89127 1.0086 5.46734 1.32116 5.15478C1.63372 4.84222 2.05765 4.66663 2.49967 4.66663H13.333C13.775 4.66663 14.199 4.84222 14.5115 5.15478C14.8241 5.46734 14.9997 5.89127 14.9997 6.33329V7.99996"
        stroke={color}
        stroke-linecap="round"
      />
      <path
        d="M14.166 12.1666L19.166 12.1666M19.166 12.1666L16.666 14.6666M19.166 12.1666L16.666 9.66663"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NewsLetterIcon;
